var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"empty-comment-card"}},[_c('img',{attrs:{"src":require("./empty-comments.svg"),"alt":"No comments yet"}}),_c('p',[_vm._v("No comments yet")])])
}]

export { render, staticRenderFns }